import { useState } from 'react';
import { Fab, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppToggleWidget = () => {
  const [visible] = useState(true);

  const handleClick = () => {
    window.open(
      'https://api.whatsapp.com/send?phone=919599446136&text=Hello',
      '_blank'
    );
  };

  return (
    <Zoom in={visible}>
      <Fab
        color="success"
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          backgroundColor: '#25D366',
          color: '#fff',
          scale: 0.9,
          '&:hover': {
            backgroundColor: '#20b358',
            scale: 1.0
          },
          zIndex: 1000
        }}
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon />
      </Fab>
    </Zoom>
  );
};

export default WhatsAppToggleWidget;
